import React, { createContext, useState, useEffect, useContext } from "react";
import { useShowAlert } from "../context/AlertContext"; 
import Messages from "../constants/Messages";

const NetworkContext = createContext();

export const NetworkProvider = ({ children }) => {
    const [isOnline, setIsOnline] = useState(navigator.onLine);
    const showAlert = useShowAlert(); 

    useEffect(() => {
        
        const handleOnline = () => {
            setIsOnline(true);
            showAlert("success", Messages.NETWORK.ONLINE);
        };

        const handleOffline = () => {
            setIsOnline(false);
            showAlert("warning", Messages.NETWORK.NO_INTERNET);
        };

        window.addEventListener("online", handleOnline);
        window.addEventListener("offline", handleOffline);

        return () => {
            window.removeEventListener("online", handleOnline);
            window.removeEventListener("offline", handleOffline);
        };
    }, [showAlert]);

    const checkNetwork = () => {
        if (!isOnline) {
            showAlert("warning", Messages.NETWORK.NO_INTERNET);
            return false;
        }
        return true;
    };


    return (
        <NetworkContext.Provider value={{ isOnline, checkNetwork }}>
            {children}
        </NetworkContext.Provider>
    );
};

export const useNetwork = () => useContext(NetworkContext);